module.exports = __webpack_public_path__ + "img/p8.b9732131.png";